import axios from 'axios';
import { USER_ROLES } from '../utils/const';
export const login = async (user) => {
  let res;
  res = await axios.post(`/user/v1/login`, {
    ...user,
    userRole: USER_ROLES.BP_ADMIN,
  });
  if (!res?.data) {
    if (res?.status === 404) throw Error('Invalid Email or Password');
    else throw Error(res.message);
  }
  return res.data;
};
export const getUser = async () => {
  const res = await axios.get(`/user/v1`);
  return res.data.user;

};

export const googleLogin = async (user) => {
  let res;
  res = await axios.post(`/user/v1/authgoogle`, { ...user, userRole: USER_ROLES.BP_ADMIN });
  if (!res?.data) {
    if (res?.status === 404) throw Error('We cannot sign in to your account');
    else throw Error(res.message);
  }
  return res.data;
};


